import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Adressen from "@/pages/Adressen";
import AdresDetail from "@/pages/AdresDetail";
import Meldingen from "@/pages/Meldingen";
import MeldingDetail from "@/pages/MeldingDetail";
import Instellingen from "@/pages/Instellingen";
import Kaart from "@/pages/Kaart";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-500 font-mono text-xs">LADEN…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/adressen" element={<Protected><Adressen /></Protected>} />
          <Route path="/adressen/:id" element={<Protected><AdresDetail /></Protected>} />
          <Route path="/meldingen" element={<Protected><Meldingen /></Protected>} />
          <Route path="/meldingen/:id" element={<Protected><MeldingDetail /></Protected>} />
          <Route path="/kaart" element={<Protected><Kaart /></Protected>} />
          <Route path="/instellingen" element={<Protected><Instellingen /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
